import { Box } from '@mui/material';
import HandbookSearchResultItem from './HandbookSearchResultItem';
import { ListItem, SearchResultsLayoutProps, useListContext } from 'framework/list';
import { Alert } from 'framework/ui/mui-builder';
import { ShowContextProvider, ShowData } from 'framework/show';

const HandbookSearchResults = (props: SearchResultsLayoutProps) => {
  const { loading, data: { items = [] } = {} } = useListContext();

  return loading ? null : (
    <Box>
      {items.length ? (
        items.map((row: ListItem, index: number) => (
          <ShowContextProvider
            key={row.id}
            value={{
              data: new ShowData(row),
            }}
          >
            <HandbookSearchResultItem {...props} row={row} index={index} />
          </ShowContextProvider>
        ))
      ) : (
        <Alert color="info" sx={{ mt: 1.5 }}>
          No results were found.
        </Alert>
      )}
    </Box>
  );
};

export default HandbookSearchResults;
